export default {"src":"/_next/static/media/ellipse6.cc5bb519.svg","height":176,"width":176,"blurWidth":0,"blurHeight":0};